import React, { useEffect, useRef, useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "../../styles/admin/institutionCourseCard.scss";
import TooltipText from "../common/tooltipText";

const InstitutionCourseCard = ({
  course,
  onClick,
  onEdit,
  onAdd,
  onDelete,
  hideMenuIcon = false,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const menuRef = useRef(null);

  const boardName = course?.board?.name || course?.board || "";
  const className =
    course?.class_name?.name ||
    course?.class_name ||
    course?.class?.name ||
    course?.class ||
    "";

  const titleText =
    (course?.name
      ? course.name.charAt(0) + course.name.slice(1)
      : undefined) ||
    course?.title ||
    "Untitled Course";

  const descText =
    course?.syllabus_description ||
    course?.description ||
    "No short description";

  const onDocClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMenu(false);
    }
  };

  const handleClick = () => onClick && onClick(course);
  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit && onEdit(course);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete && onDelete(course);
  };
  const handleMenuBtn = (e) => {
    e.stopPropagation();
    setOpenMenu((s) => !s);
  };

  const formatDateTime = (dt) => {
    if (!dt) return "--";
    try {
      const d = new Date(dt);
      if (Number.isNaN(d.getTime())) return String(dt);
      return d.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return String(dt);
    }
  };

  useEffect(() => {
    if (openMenu) document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [openMenu]);

  return (
    <div
      className="course-card"
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      <div className="course-card-title-container">
        <div className="course-card-heading">
          <div className="course-card-title">
            <span className="course-title-text">{titleText}</span>
          </div>
          {(boardName || className) && (
            <div className="course-card-chips">
              {boardName && (
                <span className="course-chip board-chip">
                  <span className="chip-label">Board:</span> {boardName}
                </span>
              )}
              {className && (
                <span className="course-chip class-chip">
                  <span className="chip-label">Class:</span> {className}
                </span>
              )}
            </div>
          )}
        </div>
        {!hideMenuIcon && (
          <div className="course-actions" ref={menuRef}>
            <button
              className="action-btn"
              onClick={handleMenuBtn}
              aria-haspopup="menu"
              aria-expanded={openMenu}
              aria-label="Course actions"
              type="button"
            >
              <MoreVertIcon fontSize="small" />
            </button>
            {openMenu && (
              <div
                className="course-actions-menu"
                role="menu"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="actions-item"
                  onClick={handleEdit}
                  role="menuitem"
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <EditOutlinedIcon fontSize="small" /> Edit
                  </span>
                </button>

                <button
                  type="button"
                  className="actions-item danger"
                  onClick={handleDelete}
                  role="menuitem"
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <DeleteOutlineIcon fontSize="small" /> Delete
                  </span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="course-card-times">
        <span className="time-item">
          <TooltipText
            text={`Created: ${formatDateTime(course?.created_at)}`}
            always
            fullWidth
            placement="bottom"
          />
        </span>
        <span className="time-item">
          <TooltipText
            text={`Updated: ${formatDateTime(course?.updated_at)}`}
            always
            fullWidth
            placement="bottom"
          />
        </span>
      </div>
    </div>
  );
};

export default InstitutionCourseCard;
